import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { Account, LoginModalService, LoginService, Principal } from 'src/app/core';
import { StateStorageService } from 'src/app/core/auth/state-storage.service';
import { BulkDeclarationService } from 'src/app/entities/bulk-declaration';
import { NotificationService } from 'src/app/shared/notification.service';
import { RoleUtil } from 'src/app/shared/util/role-util';
import { Clients } from 'src/environments/clients';
import { environment } from 'src/environments/environment';
import { VERSION } from '../../app.constants';
import { LanguageChangeService } from '../../shared/services/language-change.service';
import { AuthServerProvider } from './../../core/auth/auth-session.service';
import { CertificateRequestDataPreFill } from './../../core/certificate/certificate-request-prefill.service';
import { CommonUtils } from 'src/app/shared/util/common-utils';
import { TypeOfClient } from 'src/app/shared/model/client.model';




@Component({
    selector: 'jhi-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['navbar.scss']
})
export class NavbarComponent implements OnInit {

    public readonly RoleUtil = RoleUtil;

    inProduction: boolean;
    isNavbarCollapsed: boolean;
    languages: any[];
    swaggerEnabled: boolean;
    modalRef: NgbModalRef;
    version: string;
    account: Account;
    role: any;
    isTrader: boolean;
    languageName: any;
    currentAccount: any;
    intervalId: number;
    subscription: Subscription;

    webLogo = environment.logo
    isVerheyenLogo = false;

    icons = environment.icons;
    isBlochainEnabled = environment.blockchainEnabled;
    selectedClient = environment.login


    constructor(
        public loginService: LoginService,
        public principal: Principal,
        private loginModalService: LoginModalService,
        private router: Router,
        private languageChangeService: LanguageChangeService,
        private stateStorageService: StateStorageService,
        private authServerProvider: AuthServerProvider,
        private notificationService: NotificationService,
        private bulkDeclarationService: BulkDeclarationService,
        private certificateRequestDataPreFill: CertificateRequestDataPreFill

    ) {
        this.version = VERSION ? 'v' + VERSION : '';
        this.isNavbarCollapsed = true;
    }
    //*ngIf="authority === 'ROLE_ADMIN' && authority === 'ADMIN_STAFF'"
    ngOnInit() {

        this.isVerheyenLogo = environment.login == Clients.VERHEYEN;

        this.onLanguageChangeHelper(this.stateStorageService.getLanguageKey() === 'de' ? true : false);


        if (!localStorage.getItem('currentUser')) {
            return;
        }
        this.principal.identity().then(account => {
            this.currentAccount = account;
        });
        this.role = this.principal;

        this.typeOfClient();

        // if (this.loginService.messages.length == 0) {
        //     this.loginService.notificationMessagesAndCount()
        // }

        if (CommonUtils.isNotNil(localStorage.getItem('currentUser')) && !this.principal.alreadyCalled) {
            let url = this.router.url
            if (url == '/' || url == '/login') {
                this.router.navigate(['/dashboard']);
            }
        }
        console.log(this.principal);
    }



    //auditor
    navigateToProfile() {
        //underwriters
        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        localStorage.removeItem('profileId')
        this.loginService.getLogInUserProfileId().subscribe(data => {
            let url = '';
            if (!(this.principal.authority == 'SPOT_CLIENT')) {
                url = "user-management/";

            }
            let loggedInUserProfileId = data.body;
            if (currentUser.userRole.includes('_STAFF')) {
                url += 'internal-staff';
            } else if (currentUser.userRole.includes('CLAIMANT')) {
                url = 'claimant';
            } else if (currentUser.userRole.includes('AUDIT_USER')) {
                url += 'auditor';
            } else
                if (currentUser.userRole.includes('UNDERWRITER')) {
                    url += 'underwriters';
                } else if (currentUser.userRole.includes('INSURER')) {
                    url += 'insurer';
                } else {
                    url += currentUser.userRole.toLowerCase();
                }
            localStorage.setItem('profileId', loggedInUserProfileId);
            this.collapseNavbar();
            this.router.navigate([url, loggedInUserProfileId, 'view']);
        }, err => { });

    }

    collapseNavbar() {
        this.isNavbarCollapsed = true;
        // this.router.navigateByUrl("/dashboard");
    }

    isAuthenticated() {
        let authenticated = this.principal.isAuthenticated();
        if (!authenticated) {
            this.authServerProvider.logout();
        }
        return authenticated;
    }

    onLoginPage() {
        if (this.router.url == '/login') {
            return true;
        } else {
            return false;
        }
    }

    login() {
        this.modalRef = this.loginModalService.open();
    }

    logout() {
        this.collapseNavbar();
        this.loginService.logout();
        // this.router.navigate(['']);
    }

    toggleNavbar() {
        this.isNavbarCollapsed = !this.isNavbarCollapsed;
    }

    getImageUrl() {
        return this.isAuthenticated() ? this.principal.getImageUrl() : null;
    }

    typeOfClient() {
        if (this.principal.userIdentity) {
            if (this.principal.userIdentity.typeOfClient === TypeOfClient.TRADER) {
                // this.isTrader = true;
                return false;
            } else if (this.principal.userIdentity.typeOfClient === TypeOfClient.FREIGHT_FORWARDER) {
                // this.isTrader = false;
                return this.principal.getCertificateClientManagement;
            }
        }


    }

    getFullName() {
        let fullName = '';
        if (this.isAuthenticated()) {
            fullName =
                this.principal.userIdentity && this.principal.userIdentity.firstName ? this.principal.userIdentity.firstName + ' ' : '';
            fullName += this.principal.userIdentity && this.principal.userIdentity.lastName ? this.principal.userIdentity.lastName : '';
        }
        return fullName;
    }

    getPermissionsCheck() {
        const loggedinUserPermissions = this.principal.userIdentity.authorities[0];
        const allowedPermissions = [
            'BROKER',
            'BROKER_STAFF',
            'AUDIT_USER_STAFF',
            'AUDIT_USER',
            'UNDERWRITER',
            'UNDERWRITER_STAFF',
            'INSURER',
            'INSURER_STAFF'
        ];
        return allowedPermissions.indexOf(loggedinUserPermissions) >= 0;
    }

    getMyCertificate() {
        this.stateStorageService.resetCertificateDTO();
        this.stateStorageService.resetClientDTO();

        localStorage.removeItem('cargoDetail');
        localStorage.removeItem('shippingDetail');
        localStorage.removeItem('tradeDetails');
        this.router.navigateByUrl('/certificate/my-certificate');
    }

    getCertificate() {
        // clearing the certificate DTO list and other tab details
        this.stateStorageService.resetCertificateDTO();
        this.stateStorageService.resetClientDTO();
        localStorage.removeItem('cargoDetail');
        localStorage.removeItem('shippingDetail');
        localStorage.removeItem('tradeDetails');

        if (this.principal.userIdentity.authorities[0] === 'CLIENT' || this.principal.userIdentity.authorities[0] === 'CLIENT_STAFF') {
            if (this.principal.userIdentity.typeOfClient === TypeOfClient.TRADER) {
                this.router.navigateByUrl('/certificate/trader');
                // this.isTrader = true;
            } else {
                this.router.navigateByUrl('/certificate/trade-Details');
                // this.isTrader = false;
            }
        } else if (this.getPermissionsCheck()) {
            this.router.navigateByUrl('/certificate/broker-get-certificate');
        }
    }

    getDeclaration() {
        this.router.navigateByUrl('/my-declaration/broker-get-declaration');
    }

    get authority() {
        if (this.principal.userIdentity) {
            return this.principal.userIdentity.authorities[0];
        }
    }

    get isFreightForwarder() {
        return this.principal.userIdentity.isFreightForwarder;
    }

    get createdByAdminRole() {
        return this.principal.userIdentity.createdByUserRole;
    }
    //window.location.reload() onLanguageChange
    onLanguageChange(event) {
        this.onLanguageChangeHelper(event);
        let path = window.location.pathname;
        // let search=window.location.search;
        // let queryName;
        // let queryValue;
        // if(search!=null) {
        //     let ind=search.lastIndexOf("&");
        //     if(ind!=-1) {
        //         search=search.substring(1,ind)
        //     } else {
        //         search=search.substring(1);
        //     }
        //     let queries=search.split("=");
        //     queryName=queries[ 0 ];
        //     queryValue=queries[ 1 ];
        //     let params={}
        //     if(queryName&&queryValue) {
        //         params={
        //             [queryName]: queryValue,
        //             "refresh": new Date().getTime()
        //         }
        //     } else {
        //         params={
        //             refresh: new Date().getTime()
        //         }
        //     }
        //     this.router.navigate([ path ],{queryParams: params});
        // } else {
        //     this.router.navigate([ path ],{queryParams: {refresh: new Date().getTime()}});
        // }
        this.router.navigate([path], { queryParams: { refresh: new Date().getTime() } });
        // this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        //     this.router.navigate([path]);
        // }); 
        // window.location.reload()
    }
    onLanguageChangeHelper(event) {
        let lan = event ? 'de' : 'en';
        this.stateStorageService.resetLanguageKey();
        this.stateStorageService.storeLanguageKey(lan);
        this.languageChangeService.changeLanguage(lan);
        this.languageName = lan;
        // if (event) {
        //     this.stateStorageService.resetLanguageKey();
        //     this.stateStorageService.storeLanguageKey('de');
        //     this.languageChangeService.changeLanguage('de');
        //     this.languageName = 'de';
        // } else {
        //     this.stateStorageService.resetLanguageKey();
        //     this.stateStorageService.storeLanguageKey('en');
        //     this.languageChangeService.changeLanguage('en');
        //     this.languageName = 'en';
        // }
    }

    makeNotificationsZero() {
        // this.loginService.notificationCount = this.loginService.notificationCount -1;

    }

    navigateToNotification(notification, index: number) {

        this.notificationService.navigateToNotification(notification);
    }

    markAsRead() {
        this.notificationService.markReadAllByUser().subscribe(response => {
            this.loginService.notificationMessagesAndCount()
        });
    }
    //client and client staff storage permission


}
